import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import PlatformPortMappingViewForm from './PlatformPortMappingViewForm'
import PlatformPortMappingAddForm from './PlatformPortMappingAddForm'
import PlatformPortMappingEditForm from './PlatformPortMappingEditForm'
import Namespace from 'src/constants/locale/Namespace'
import PlatformPortMappingKeys from 'src/constants/locale/key/PlatformPortMapping'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [platformPortMappingId, setPlatformPortMappingId] = useState('')
  const { translate } = useTranslation([
    Namespace.PLATFORM_PORT_MAPPING,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let platformPortMapping = translate(
      Namespace.PLATFORM_PORT_MAPPING,
      PlatformPortMappingKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: platformPortMapping
      }
    )

    return {
      platformPortMapping,
      tabLockedMessage
    }
  }

  function makePlatformPortMappingForm() {
    if (platformPortMappingId === '') {
      return (
        <PlatformPortMappingAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setPlatformPortMappingId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <PlatformPortMappingEditForm
          showNotification={showNotification}
          id={platformPortMappingId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <PlatformPortMappingViewForm
              showNotification={showNotification}
              id={platformPortMappingId}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.platformPortMapping,
              tabContent: makePlatformPortMappingForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage